import type { AdminUserRow } from '@trendator/shared';
import { useEffect, useState } from 'react';
import { Card, Empty, ErrorBox, Input, Loading, Status, Table } from '../components/ui';
import { api } from '../lib/api';
import { date, num, rub } from '../lib/format';
import { useLoad } from '../lib/hooks';
import { navigate, setQuery } from '../lib/router';

export function Users({ query }: { query: URLSearchParams }) {
  const q = query.get('q') ?? '';
  const [search, setSearch] = useState(q);
  const list = useLoad(() => api.get<{ items: AdminUserRow[] }>(`/users${q ? `?q=${encodeURIComponent(q)}` : ''}`), [q]);

  useEffect(() => {
    const t = setTimeout(() => search !== q && setQuery({ q: search.trim() || null }), 350);
    return () => clearTimeout(t);
  }, [search, q]);

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-3.5">
        <h1 className="m-0 text-2xl font-extrabold tracking-tight lg:text-[30px]">Юзеры</h1>
        <label className="min-w-[220px] flex-[0_1_360px]">
          <span className="sr-only">Поиск</span>
          <Input placeholder="@username, имя, TG id или #id" value={search} onChange={(e) => setSearch(e.target.value)} className="bg-card text-sm" />
        </label>
      </div>
      <Card className="px-2 pt-2 pb-1">
        {list.error ? <ErrorBox text={list.error} onRetry={() => void list.reload()} /> : null}
        {!list.data && list.loading ? <Loading /> : null}
        {list.data && list.data.items.length === 0 ? <Empty>Никого не нашли</Empty> : null}
        {list.data && list.data.items.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th>Юзер</th>
                <th>TG id</th>
                <th className="text-right!">Баланс</th>
                <th className="text-right!">Оплатил</th>
                <th className="text-right!">Генераций</th>
                <th className="text-right!">С нами</th>
              </tr>
            </thead>
            <tbody>
              {list.data.items.map((u) => (
                <tr key={u.id} className="cursor-pointer hover:[&_td]:bg-white/3" onClick={() => navigate(`/users/${u.id}`)}>
                  <td className="text-muted">{u.id}</td>
                  <td>
                    <span className="flex items-center gap-2">
                      <span className="font-semibold">{u.firstName}</span>
                      {u.username ? <span className="text-muted">@{u.username}</span> : null}
                      {u.banned ? <Status tone="bad">бан</Status> : null}
                    </span>
                  </td>
                  <td className="font-mono text-xs text-muted">{u.telegramId}</td>
                  <td className="text-right font-semibold">{rub(u.balance)}</td>
                  <td className="text-right">{u.paid ? rub(u.paid) : '—'}</td>
                  <td className="text-right">{num(u.generations)}</td>
                  <td className="text-right text-muted">{date(u.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : null}
      </Card>
    </>
  );
}
